import { render, staticRenderFns } from "./q1.vue?vue&type=template&id=62fa1c3f&scoped=true&"
import script from "./q1.vue?vue&type=script&lang=js&"
export * from "./q1.vue?vue&type=script&lang=js&"
import style0 from "./q1.vue?vue&type=style&index=0&id=62fa1c3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa1c3f",
  null
  
)

export default component.exports